module.exports = __webpack_public_path__ + "static/media/50-off-campaign-everyday-digital-papers.21d21622.png";